import { Link } from 'react-router-dom';
import { CATALOG_ARCHIVE_URL } from '../../../config';
import { useContext } from 'react';
import { CategoriesContext } from '../../../App';
import { selectImage } from '../../../util/misc';

function NewIekHome() {
    const { categories } = useContext(CategoriesContext);

    return (
        <div className="catalog-content">
            <div className="catalog-content__row catalog-content__row--mobile">
                <a href={CATALOG_ARCHIVE_URL} className="ui-button ui-button--dark ui-button--file">
                    <i className="far fa-file-pdf" />
                    <span>Скачать полный каталог</span>
                </a>
            </div>
            <div className="category-items">
                {categories.map((cat) => {
                    const imageUrl = selectImage(cat.imageVariants, 400, 200, cat.imageUrl);
                    return (
                        <div key={cat.slug} className="category-item">
                            <div className="category-item__head">
                                <Link to={cat.url} className="category-item__title">
                                    {cat.name}
                                </Link>
                                {/* <a href="#" className="category-item__download" title="Скачать"> */}
                                {/*    <i className="icon-document"/> */}
                                {/* </a> */}
                            </div>
                            <div
                                className="category-item__image"
                                style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : 'none' }}
                            />

                            <div className="category-item__body">
                                <div className="category-item__subcategories">
                                    {cat.children?.map((subcat) => (
                                        <Link
                                            key={subcat.slug}
                                            to={subcat.url}
                                            className="category-item__subcategory"
                                        >
                                            {subcat.name}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default NewIekHome;
